<script setup>

import { ref, computed, defineProps, onMounted, watch} from "vue";
import { DateTime, Interval } from "luxon";
import UtilNumber from "../../../../utils/UtilNumber";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pedidoDeCompra"
]);

//==================================================================//
//========================== Busca Jobs ============================//
//==================================================================//

const buscaJobs = computed(()=>{

    return props?.pedidoDeCompra?.itens?.map(({jobCodigo})=>jobCodigo);

});
let buscaJobSelecionado = ref("");

//==================================================================//
//==================== Busca Ordens de Serviço =====================//
//==================================================================//

const buscaOrdensDeServico = computed(()=>{

    return props?.pedidoDeCompra?.itens?.map(({osCodigo})=>osCodigo);

});
let buscaOrdemDeServicoSelecionado = ref("");

//==================================================================//
//====================== Busca Situação Item =======================//
//==================================================================//

const buscaSituacoesItem = ref(["Só Pendentes","Todos os Itens"]);
let buscaSituacaoItemSelecionada = ref("Todos os Itens");

//==================================================================//
//===================== Formata Data Entrega =======================//
//==================================================================//

let formataDataEntrega = (dataEntrega) =>{

    return DateTime.fromFormat(dataEntrega,"dd/MM/yyyy").toFormat("yyyy-MM-dd");

};

//==================================================================//
//====================== Busca Data Entrega ========================//
//==================================================================//

let buscaDataEntregaInicio = ref("");
let buscaDataEntregaFim = ref("");


//==================================================================//
//===================== Filter Pedidos Header ======================//
//==================================================================//

const filterJob = (job) =>{

    if(!buscaJobSelecionado.value){
        return true;
    }

    return job.toLowerCase().includes(buscaJobSelecionado.value.toLowerCase());

}

const filterOrdemDeServico = (ordemDeServico) =>{

    if(!buscaOrdemDeServicoSelecionado.value) {
        return true;
    }

    return ordemDeServico.toLowerCase().includes(buscaOrdemDeServicoSelecionado.value.toLowerCase());

}

const filterBuscaSituacoesItem = (ordemDeServicoItemStatus) =>{

    if(buscaSituacaoItemSelecionada.value == "Todos os Itens") {
        return true;
    }

    if(ordemDeServicoItemStatus == "GP" || ordemDeServicoItemStatus == "RP"){
        return true;
    }

    return false;

}

const filterBuscaDataEntrega = (dataEntregaItem) =>{

    if(buscaDataEntregaInicio.value == "" || buscaDataEntregaFim.value == ""){
        return true;
    }

    let dataEntregaInicio = DateTime.fromFormat(buscaDataEntregaInicio.value,"yyyy-MM-dd").startOf("day");
    let dataEntregaFim = DateTime.fromFormat(buscaDataEntregaFim.value,"yyyy-MM-dd").endOf("day");
    dataEntregaItem = DateTime.fromFormat(dataEntregaItem,"dd/MM/yyyy");

    const intervaloDeTempo = Interval.fromDateTimes(dataEntregaInicio, dataEntregaFim);
    let dataEntregaEstaNointervalo = intervaloDeTempo.contains(dataEntregaItem);

    return dataEntregaEstaNointervalo;

}

//==================================================================//
//========================== Itens Header ==========================//
//==================================================================//

let itensHeaders = [
    { text: 'Job',                                  value: 'jobCodigo',                                                class:"c-tabela__header",    cellClass:'c-tabela__item', filter: filterJob},
    { text: 'Cliente',                              value: 'clienteNome',                                              class:"c-tabela__header",    cellClass:'c-tabela__item'},
    { text: 'OS',                                   value: 'osCodigo',                                                 class:"c-tabela__header",    cellClass:'c-tabela__item', filter: filterOrdemDeServico},
    { text: 'Sequência',                            value: 'osItemSequencia',                                          class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false},
    { text: 'Código do Item',                       value: 'osItemItemCodigo',                                         class:"c-tabela__header",    cellClass:'c-tabela__item'},
    { text: 'Descrição',                            value: 'osItemDescricao',                                          class:"c-tabela__header",    cellClass:'c-tabela__item', width:"550"},
    { text: 'Fornecedor Material Fornecido',        value: 'osItemFornecedorMaterialFornecidoDescricao',               class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false},
    { text: 'Data de Solicitação',                  value: 'osItemDataSolicitacao',                                    class:"c-tabela__header",    cellClass:'c-tabela__item'},
    { text: 'Data de Necessidade',                  value: 'osItemDataNecessidade',                                    class:"c-tabela__header",    cellClass:'c-tabela__item'},
    { text: 'Data de Entrega',                      value: 'osItemDataEntrega',                                        class:"c-tabela__header",    cellClass:'c-tabela__item', filter: filterBuscaDataEntrega},
    { text: 'Quantidade Solicitada',                value: 'osItemQuantidade',                                         class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false},
    { text: 'Unidade Solicitada',                   value: 'osItemUnidadeSigla',                                       class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false},
    { text: 'Quantidade',                           value: 'osItemQuantidadeCompra',                                   class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false},
    { text: 'Unidade',                              value: 'osItemUnidadeCompraSigla',                                 class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false},
    { text: 'Preço Unitario',                       value: 'osItemPrecoUnitarioComImpostos',                           class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false,  width:"150", },
    { text: '%Desconto',                            value: 'osItemPrecoUnitarioComImpostosPorcentagemDoDesconto',      class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false,  width:"150", },
    { text: 'Preço Unitario com Desconto',          value: 'osItemPrecoUnitarioComImpostosComDesconto',                class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false,  width:"150", },
    { text: 'Preço Total',                          value: 'osItemPrecoTotalComImpostos',                              class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false,  width:"150", },
    { text: '%ISS',                                 value: 'osItemPorcentagemISS',                                     class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false,  width:"150", },
    { text: '%ICMS',                                value: 'osItemPorcentagemICMS',                                    class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false,  width:"150", },
    { text: 'Valor ICMS',                           value: 'osItemValorICMS',                                          class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false,  width:"150", },
    { text: '%IPI',                                 value: 'osItemPorcentagemIPI',                                     class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false,  width:"150", },
    { text: 'Valor IPI',                            value: 'osItemValorIPI',                                           class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false,  width:"150", },
    { text: 'Preço Total com Impostos com IPI',     value: 'osItemPrecoTotalComImpostosComIPI',                        class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false,  width:"150", },
    { text: 'Preço Total sem Impostos com IPI',     value: 'osItemPrecoTotalSemImpostosComIPI',                        class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false,  width:"150", },
    { text: 'Valor Disponivel',                     value: 'osItemValorDisponivel',                                    class:"c-tabela__header",    cellClass:'c-tabela__item', filterable: false,  width:"150", },
    { text: 'Status (Item)',                        value: 'osItemStatus',                                             class:"c-tabela__header",    cellClass:'c-tabela__item', filter: filterBuscaSituacoesItem},
]

//==================================================================//
//======================= Item Campos Regras =======================//
//==================================================================//

const itemDataEntregaRegras =  [
    valor => {
        if(valor == ""){
            return false;
        }
        return true;
    }
];

//==================================================================//
//====================== Altera Data Entrega =======================//
//==================================================================//

const alteraBuscaDataEntregaInicio = (dataEntregaInicio)=>{

    dataEntregaInicio = DateTime.fromFormat(dataEntregaInicio,"yyyy-MM-dd");

    if(!dataEntregaInicio.isValid){
        buscaDataEntregaInicio.value = "";
        return;
    }

    buscaDataEntregaInicio.value = dataEntregaInicio.toFormat("yyyy-MM-dd");

}

//==================================================================//
//====================== Altera Data Entrega =======================//
//==================================================================//

const alteraBuscaDataEntregaFim = (dataEntregaFim)=>{
    
    dataEntregaFim = DateTime.fromFormat(dataEntregaFim,"yyyy-MM-dd");

    if(!dataEntregaFim.isValid){
        buscaDataEntregaFim.value = "";
        return;
    }

    buscaDataEntregaFim.value = dataEntregaFim.toFormat("yyyy-MM-dd");

}

//==================================================================//
//=================== Valor Monetario Formatado ====================//
//==================================================================//

const valorMonetarioFormatado = (valor = 0)=>{

    return new Intl.NumberFormat('default', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(UtilNumber.clamp(valor,-999999999,999999999));

};

//==================================================================//
//=========================== On Load ==============================//
//==================================================================//

const onLoad = () =>{

    buscaJobSelecionado.value = "";
    buscaOrdemDeServicoSelecionado.value = "";

    buscaSituacaoItemSelecionada.value = "Todos os Itens";

    buscaDataEntregaInicio.value = formataDataEntrega(props?.pedidoDeCompra?.itensPrimeiraDataEntrega);
    buscaDataEntregaFim.value = formataDataEntrega(props?.pedidoDeCompra?.itensUltimaDataEntrega);

};

//==================================================================//
//========================== On Mounted ============================//
//==================================================================//

onMounted(async ()=>{

    onLoad();

});

//==================================================================//
//==================== Watch Pedido de Compra ======================//
//==================================================================//

watch(()=> props.pedidoDeCompra, (pedidoDeCompra) => {

    if(pedidoDeCompra.id){
        onLoad();
    }

});


</script>

<template>

    <v-card
        class="c-itens"
    >

        <v-card-title
            class="c-itens__header"
        >
        
            <h3 
                class="c-header__titulo"
            >
                Itens
            </h3>

            <div
                class="c-header__buscas"
            >

                <div class="c-busca c-busca--jobs">

                    <v-select
                        label="Job"
                        class="c-busca__input"
                        v-model="buscaJobSelecionado"
                        :items="buscaJobs"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                        :disabled="props?.controlesDesativados"
                    ></v-select>

                </div>

                <div class="c-busca c-busca--ordens-de-servico">

                    <v-select
                        label="Ordem de Serviço"
                        class="c-busca__input"
                        v-model="buscaOrdemDeServicoSelecionado"
                        :items="buscaOrdensDeServico"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                        :disabled="props?.controlesDesativados"
                    ></v-select>

                </div>

                <div class="c-busca c-busca--situacao-item">

                    <v-select
                        label="Situação"
                        class="c-busca__input"
                        v-model="buscaSituacaoItemSelecionada"
                        :items="buscaSituacoesItem"
                        hide-details
                        outlined
                        return-object
                        :disabled="props?.controlesDesativados"
                    ></v-select>

                </div>

                <div class="c-busca c-busca--situacao-item">

                    <v-select
                        label="Situação"
                        class="c-busca__input"
                        v-model="buscaSituacaoItemSelecionada"
                        :items="buscaSituacoesItem"
                        hide-details
                        outlined
                        return-object
                        :disabled="props?.controlesDesativados"
                    ></v-select>

                </div>

                <div class="c-busca c-busca--data-entrega">

                    <fieldset class="c-busca__grupo c-busca__grupo--horizontal">

                        <legend
                            class="c-grupo__titulo"
                        >
                            Data Entrega
                        </legend>

                        <span class="c-busca__inner-label">De</span>

                        <v-text-field
                            class="c-busca__input"
                            :value="buscaDataEntregaInicio"
                            outlined
                            type="date"
                            prepend-icon="mdi-calendar" 
                            :disabled="props.controlesDesativados"
                            :rules="itemDataEntregaRegras"
                            hide-details
                            @input="alteraBuscaDataEntregaInicio"
                        ></v-text-field>

                        <span class="c-busca__inner-label">até</span>

                        <v-text-field
                            class="c-busca__input"
                            :value="buscaDataEntregaFim"
                            outlined
                            type="date"
                            prepend-icon="mdi-calendar" 
                            :disabled="props.controlesDesativados"
                            :rules="itemDataEntregaRegras"
                            hide-details
                            @input="alteraBuscaDataEntregaFim"
                        ></v-text-field>

                    </fieldset>

                </div>


            </div>

        </v-card-title>

        <div
            class="c-itens__conteudo"
        >

            <v-data-table
                class="c-itens__tabela elevation-1"
                :headers="itensHeaders"
                :items="props.pedidoDeCompra.itens"
                :items-per-page="-1"
                item-key="id"
            >

                <template v-slot:item.osItemValorDisponivel="{ item }">

                    R$ {{valorMonetarioFormatado(item?.osItemValorDisponivel)}}

                </template>

                <template v-slot:item.osItemPrecoUnitarioComImpostos="{ item }">

                    R$ {{valorMonetarioFormatado(item?.osItemPrecoUnitarioComImpostos)}}

                </template>

                <template v-slot:item.osItemPrecoUnitarioComImpostosComDesconto="{ item }">

                    R$ {{valorMonetarioFormatado(item?.osItemPrecoUnitarioComImpostosComDesconto)}}

                </template>

                <template v-slot:item.osItemPrecoUnitarioComImpostosPorcentagemDoDesconto="{ item }">

                    {{item?.osItemPrecoUnitarioComImpostosPorcentagemDoDesconto}}%

                </template>

                <template v-slot:item.osItemPrecoTotalComImpostos="{ item }">

                    R$ {{valorMonetarioFormatado(item?.osItemPrecoTotalComImpostos)}}

                </template>

                <template v-slot:item.osItemPorcentagemISS="{ item }">

                    {{item?.osItemPorcentagemISS}}%

                </template>

                <template v-slot:item.osItemPorcentagemICMS="{ item }">

                    {{item?.osItemPorcentagemICMS}}%

                </template>

                <template v-slot:item.osItemValorICMS="{ item }">

                    R$ {{valorMonetarioFormatado(item?.osItemValorICMS)}}

                </template>

                <template v-slot:item.osItemPorcentagemIPI="{ item }">

                    {{item?.osItemPorcentagemIPI}}%

                </template>

                <template v-slot:item.osItemValorIPI="{ item }">

                    R$ {{valorMonetarioFormatado(item?.osItemValorIPI)}}

                </template>

                <template v-slot:item.osItemPrecoTotalComImpostosComIPI="{ item }">

                    R$ {{valorMonetarioFormatado(item?.osItemPrecoTotalComImpostosComIPI)}}

                </template>

                <template v-slot:item.osItemPrecoTotalSemImpostosComIPI="{ item }">

                    R$ {{valorMonetarioFormatado(item?.osItemPrecoTotalSemImpostosComIPI)}}

                </template>

            </v-data-table>

        </div>

    </v-card>


</template>

<style scoped>

.c-itens__header{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr auto; 
    grid-template-areas: 
    "titulo"
    "buscas";
    gap: 10px;
    align-items: start;
}

.c-header__buscas{
    grid-area: buscas;
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px;
    grid-template-areas: 
        "buscaJobs buscaSituacaoItem"
        "buscaOrdensDeServico buscaDataEntrega";
}

.c-busca--jobs{
    grid-area: buscaJobs;
}

.c-busca--ordens-de-servico{
    grid-area: buscaOrdensDeServico;
}

.c-busca--situacao-item{
    grid-area: buscaSituacaoItem;
}

.c-busca--data-entrega{
    grid-area: buscaDataEntrega;
}

.c-busca__grupo{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    padding: 5px;
}

.c-busca__inner-label{
    font-size: 12px;
}

.c-busca__grupo--horizontal{
    flex-direction: row;
}

.c-grupo__titulo{
    font-size: 10px;
    padding: 0;
    color: rgba(0, 0, 0, 0.9);
    letter-spacing: 0;
    padding-inline: 2px;
    line-height: normal;
}

.c-itens__tabela{
    display: grid;
    white-space: nowrap;
}

</style>